import { useEffect } from 'react';

import { useQuery } from '@zenbusiness/application-commons-graphql';

import { TOKEN_TYPES } from '#client/constants/tokens';
import useCustomerToken from '#client/hooks/useCustomerToken';
import { useLogError } from '#client/hooks/useLogError';
import useToastContext from '#client/hooks/useToastContext';
import useUnitAccountId from '#client/hooks/useUnitAccountId';
import { GET_COUNTERPARTY } from '#client/queries';

export default function useCounterpartyDetails({ counterpartyId }) {
  const { createCommonErrorToast } = useToastContext();
  const {
    customerToken,
    loading: customerTokenLoading,
    error: customerTokenError
  } = useCustomerToken({
    type: TOKEN_TYPES.COMMON,
    prefetch: true
  });

  const { isEnabled, isEnrolled, isValidMfa } = useUnitAccountId();

  const skipQuery = !counterpartyId || !isEnabled || !isEnrolled || !isValidMfa || !customerToken;
  const { error, errors, data, loading } = useQuery(GET_COUNTERPARTY, {
    variables: {
      filter: {
        counterpartyId,
        customerToken
      }
    },
    skip: skipQuery,
    skipCache: true,
    noThrow: true
  });

  useLogError(errors, error);
  useEffect(() => {
    if (error) {
      createCommonErrorToast({ error });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return {
    counterPartyData: data?.bankingCounterparty || null,
    fetchingCounterparty: loading || customerTokenLoading,
    counterpartyError: error || customerTokenError
  };
}
